/**
 * Author:hong.rong
 * Desc:
 * Date:2022-02-27
 */

import * as React from 'react'
// import Image from 'next/image'
import SP, { Autoplay } from 'swiper'
import { Swiper, SwiperSlide } from 'swiper/react'
import { useTranslation } from '@/libs/next-lang'
import { IconSvg } from '@/components'
import styles from './index.module.less'

SP.use([Autoplay])

export default function Banner({ translateTxt, onRouteChange }: any) {
  const { t } = useTranslation(['dashboard']);

  const items = [
    {
      key: 1,
      url: t('dashboard:image.t1'),
    },
  ]
  const length = items.length
  return (
    <div className={styles.banner}>
      <Swiper
        style={{ height: '100%' }}
        allowTouchMove={false}
        slidesPerView={1}
        loop={length > 1}
        autoplay={
          length > 1
            ? {
                delay: 2000,
                disableOnInteraction: false,
                pauseOnMouseEnter: true,
              }
            : false
        }
      >
        {items.map(item => (
          <SwiperSlide key={item.key}>
            <div className={styles['slider-item']}>
              <img draggable={false} loading="lazy" src={item.url} alt="banner" />
              {/* <Image
                alt="banner"
                src={item.url}
                fill
                style={{
                  objectFit: 'contain',
                  objectPosition: 'left top'
                }}
              /> */}
            </div>
            <div className={styles.section}>
              <div className={styles.title}>Creative Booster</div>
              <div className={styles.subtitle}>{translateTxt('dashboard:t1')}</div>
              <p className={styles.desc}>{translateTxt('dashboard:t2')}</p>
              <p className={styles.desc}>{translateTxt('dashboard:t3')}</p>
              <div
                className={`${styles.btn} bannerButton`}
                onClick={() => onRouteChange('/inspiration/template')}
              >
                {translateTxt('dashboard:t4')}{' '}
                <IconSvg style={{ marginLeft: 8, fontSize: 12 }} type="icon-xiangyou" />
              </div>
            </div>
          </SwiperSlide>
        ))}
      </Swiper>
    </div>
  )
}
